export default class TeamInvitationCommand {
  public inviteeId?: string;
  public teamId?: string;
  public message?: string;

  public constructor(Partial: Partial<TeamInvitationCommand> = {}) {
    Object.assign(this, Partial);
  }
}
